export default "__VITE_ASSET__B0RTeg6W__"